import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
} from "@/components/ui/sheet";
import { useBrandStore } from "../stores/brandStore";
import { BrandForm } from "./BrandForm";

export function BrandDrawer() {
  const drawerOpen = useBrandStore((s) => s.drawerOpen);
  const selectedIdx = useBrandStore((s) => s.selectedIdx);
  const closeDrawer = useBrandStore((s) => s.closeDrawer);

  const isEditMode = selectedIdx != null;

  const handleClose = () => {
    closeDrawer();
  };

  return (
    <Sheet
      open={drawerOpen}
      onOpenChange={(open) => {
        if (!open) handleClose();
      }}
    >
      <SheetContent
        side="right"
        className="flex flex-col overflow-hidden p-0 sm:max-w-[640px]"
      >
        <SheetHeader className="shrink-0 px-4 pt-4 pb-2">
          <SheetTitle className="text-sm">
            {isEditMode ? "브랜드 수정" : "브랜드 등록"}
          </SheetTitle>
          <SheetDescription className="text-xs">
            {isEditMode
              ? "브랜드 설정과 노출 자산을 수정합니다"
              : "새 브랜드 설정을 등록합니다"}
          </SheetDescription>
        </SheetHeader>

        {isEditMode && (
          <div className="flex shrink-0 items-center border-y border-gray-200 px-4 py-2">
            <span className="text-xs text-gray-500">
              브랜드 번호: {selectedIdx}
            </span>
          </div>
        )}

        <BrandForm
          key={selectedIdx ?? "add"}
          mode={isEditMode ? "edit" : "add"}
          idx={selectedIdx}
        />
      </SheetContent>
    </Sheet>
  );
}
